import ProfileClaimsBrowser from "./ProfileClaimsBrowser";
export default ProfileClaimsBrowser;
